$( document ).ready(function() {
  
  $('.hero-list').slick({
    arrows: false,
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    adaptiveHeight: true
  });

$('.review-slider .review-list').slick({
    dots: false,
    arrows: true,
    infinite: false,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
});



});


document.addEventListener("DOMContentLoaded", function () {
  const mobileMenu = document.querySelector(".sticky-footer .mobile_menu");
  
  if (mobileMenu) {
    mobileMenu.addEventListener("click", function () {
      const menuDrawerContainer = document.querySelector(".menu-drawer-container summary");
      if (menuDrawerContainer) {
        menuDrawerContainer.click();
      }
    });
  }
});

